export default __webpack_public_path__ + "static/media/steps.a1beb0ef.png";